import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import AddLocationAltIcon from '@mui/icons-material/AddLocationAlt';
import { Button, CircularProgress, IconButton, Skeleton } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import AddPhotoAlternateIcon from '@mui/icons-material/AddPhotoAlternate';
import { Input } from 'antd';
import CloseIcon from '@mui/icons-material/Close';


import { Rating } from "@mui/material";
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import TextArea from 'antd/es/input/TextArea';

//home-projects-each
export default function EachCategory({propsData}) {
  const location = useLocation()
  const [routes,setRoutes]=useState(location.pathname.split("/"))
  let navigate=useNavigate()
  let [Category,GetCategory]=useState({})
  let [error,setError]=useState(false)
 

  useEffect(()=>{
    setError(true)
    setRoutes(location.pathname.split("/"))
    let currentLocation=location.pathname.split("/")
    //console.log(location.pathname.split("/"));
    if(propsData?.userData?.token){
      axios.get(`${process.env.REACT_APP_URL}/api/category/GetSingleCategories/${currentLocation[2]}`, //proxy uri
      {
         headers: {
            authorization:`Bearer ${ propsData.userData?.token }`,
            'Content-Type': 'application/json'
         } 
      })
      .then(res=>{
        console.log(res.data);
        GetCategory(res.data)
        setError(false)
      })
      .catch(error=>{
        console.log(error);
      })
    }
    else{
        axios.get(`${process.env.REACT_APP_URL}/api/category/GetSingleCategories_dukana/${currentLocation[2]}`, //proxy uri
        {
          headers: {
              authorization:`Bearer ${ propsData.userData?.token }`,
              'Content-Type': 'application/json'
          } 
        })
        .then(res=>{
          console.log(res.data);
          GetCategory(res.data)
          setError(false)
        })
        .catch(error=>{
          console.log(error);
        })
    }
},[propsData.equilizer,location])

let[otherCategories,handleOtherCategories]=useState([])
let [errorOthers,setErrorErrorOthers]=useState(false)

useEffect(()=>{
  setErrorErrorOthers(true)
  
  axios.get(`${process.env.REACT_APP_URL}/api/category/GetAllCategories_dukana`, //proxy uri
  {
     headers: {
        authorization:`Bearer ${ propsData.userData?.token }`,
        'Content-Type': 'application/json'
     } 
  })
  .then(res=>{
    console.log(res.data);
    handleOtherCategories(res.data)
    setErrorErrorOthers(false)
  })
  .catch(error=>{
    console.log(error);
  })
},[propsData.equilizer,location])


let[categoryMaterials,handleCategoryMaterials]=useState([])
let [errorMaterials,setErrorErrorMaterials]=useState(false)

useEffect(()=>{
  let currentLocation=location.pathname.split("/")
  setErrorErrorMaterials(true)
  axios.get(`${process.env.REACT_APP_URL}/api/material/GetCategoryAllMaterials/${currentLocation[2]}`, //proxy uri
  {
     headers: {
        authorization:`Bearer ${ propsData.userData?.token }`,
        'Content-Type': 'application/json'
     } 
  })
  .then(res=>{
    console.log(res.data);
    handleCategoryMaterials(res.data)
    setErrorErrorMaterials(false)
  })
  .catch(error=>{
    console.log(error);
  })
},[propsData.equilizer,location])

//let [updatePage,handleUpdatePage]=useState(false)
let [addPage,handleAddPage]=useState(false)

let [sampleImage,setSampleImages]=useState([])
let [images,handleImages]=useState([])
let [name,setName]=useState("")
let [price,setPrice]=useState("")
let [description,setDescription]=useState("")

const handleChange = (e) => {
  let image = e.target.files;
  console.log(image);
  handleImages([...images, ...image]);
};

useEffect(() => {
  if (images.length > 0) {
    for (let i = 0; i < images.length; i++) {
     // console.log(images[i]);
      if (images[i].type?.startsWith('image/')) {
        let url = URL.createObjectURL(images[i]);
        setSampleImages(e=>[...e,url])
      }
    }
  }
}, [images]);

//console.log(images,sampleImage);
const [requiredKeys, setRequiredKeys] = useState({});

useEffect(() => {
  if (Category?.requiredKeys) {
    setRequiredKeys((prevState) => {
      const updatedState = { };
      for (const key of Category.requiredKeys) {
        updatedState[key] = "";
      }
      return updatedState;
    });
  }
}, [Category?.requiredKeys]);


let[disablePostButton,handlDisableButton]=useState(true)
useEffect(()=>{
    let keysWithNonEmptyValues = Object.keys(requiredKeys).filter(key => requiredKeys[key] === "");
    if (keysWithNonEmptyValues.length > 0) {
    handlDisableButton(true)
    } else {
    handlDisableButton(false)
    }
},[requiredKeys])

//console.log(requiredKeys);

let [loadMaterialAdd,handleLoadMaterialAdd]=useState(false)
let [errorMaterialAdd,handleErrorMaterialAdd]=useState(false)

const PostMaterial=()=>{
  handleLoadMaterialAdd(true)
 // console.log(newPost);
  if(images.length===0||name.length<1||price.length<1||description.length<1){
    handleErrorMaterialAdd("Please, fill all necessery fields.")
      setTimeout(()=>{
        handleErrorMaterialAdd("")
        },5000)
     handleLoadMaterialAdd(false)
      return
  }

  let fd=new FormData()                                                               
  let url=`${process.env.REACT_APP_URL}/api/material/AddNewMaterials`
    //console.log(images.length);
    for (let i = 0; i < images.length; i++) {
       console.log(images[i]);
        if (images[i].type?.startsWith('image/')) {
              fd.append("imgs",images[i])

        }
      }
  
  let currentLocation=location.pathname.split("/")
  fd.append("CategoryId",currentLocation[2])
  fd.append("name",name)
  fd.append("price",price)
  fd.append("description",description)
  fd.append("requiredKeys",JSON.stringify(requiredKeys))
  
 axios.post(url,fd, {
  headers: {
     authorization:`Bearer ${ propsData.userData?.token }`,
     'Content-Type': 'multipart/form-data',
  } 
 })

 .then(res=>{
  handleLoadMaterialAdd(false)
  //console.log(res.data);
  propsData.setEquilizer(propsData.equilizer+1)
  handleImages([])
  setSampleImages([])
  setName("")
  setPrice("")
  setDescription("")
  handleAddPage(false)
})

.catch(error=>{
  console.log(error);
  handleLoadMaterialAdd(false)
  handleErrorMaterialAdd(error?.response?.data?.error||"Error occured pleasee try again.")
  setTimeout(()=>{
    handleErrorMaterialAdd("")
  },5000)
  })
}

let sampleErrorMaterial=[1,2,3,4,5]

console.log(Category);
 
  return (
    <>
      <div className='singleCategoryContainer'>
        <div  className='singleCategoryLeft'>

            <div className='singleCategoryTop'>
                <h2 className='singleCategoryTopName'>{!error?Category?.name?.toUpperCase():<Skeleton width={150} height={50}/>}</h2>
                {!error? <Link style={{textDecoration:"none",color:"inherit"}} to={`/shop/${Category?.shop?._id}`}>
                    <div className='singleCategoryTopShopProfile'>
                        <div><img src={Category?.shop?.coverPic?.fileUrl} width={50}/></div>
                        <div style={{fontWeight:"700"}}>{Category?.shop?.shope_name}</div>
                        <div style={{fontSize:"12px"}}><AddLocationAltIcon style={{fontSize:"12px",color:"red"}}/> {Category?.shop?.country}</div>
                        <div  style={{fontSize:"12px",fontWeight:"700"}}>{Category?.shop?.shope_type}</div>
                    </div>
                </Link>:
                <div><Skeleton width={50} height={50} variant="circular"/></div>
                }
            </div>
            <div className='singleCategoryKeys'>
                <h3>Listed Keys</h3>
                <div  className='singleCategoryKeysAll'>
                    {Category?.requiredKeys?.map((e,index)=>{
                      return <div  className='singleCategoryKeysEach' key={index}>{e}</div>
                    })}
                </div>
                {Category?.shop?._id===propsData?.currentShope&&<div style={{fontSize:"13px",fontWeight:"700",textAlign:"end"}}>By {Category?.createdBy?.username}</div>}
            </div>

            <hr/>

            <div className='singleCategoryMaterials'>
                <div className='singleCategoryMaterialsTitle'>Materials {Category?.shop?._id===propsData?.currentShope&&<IconButton onClick={()=>handleAddPage(!addPage)}><AddIcon on style={{fontSize:"22px",color:"rgb(153, 117, 51)"}}/></IconButton>}</div>
                <div className='singleCategoryMateriasNo'>{(!errorMaterials&&categoryMaterials.length===0)&&"No material is exist with in this categories"}</div>
                {!errorMaterials?
                  <div className='singleCategoryMaterialsAll'>
                      {categoryMaterials?.map((e,index)=>{
                            return <EachMaterials propsData={propsData} item={e} key={index}/>
                      })}
                  </div>:
                  <div className='singleCategoryMaterialsAll'>
                       {sampleErrorMaterial.map(e=>{
                        return <Skeleton  variant="rounded"  width={210} height={150}  />
                       })}
                  </div>
                }
            </div>

        </div>

          <div  className='singleCategoryRight singleCategoryRightAllMinimized'>
                <div className='singleCategoryRightTitle'>Suggested Categories</div>
                <div className='singleCategoryRightNo'>{otherCategories.length===0&&"No material is exist with in this categories"}</div>
                
                {!errorOthers?<div className='singleCategoryRightAll'>
                      {otherCategories?.map((e,index)=>{
                            return <EachCategories item={e} key={index}/>
                      })}
                </div>:
                  <div className='singleCategoryRightAll'>
                       {sampleErrorMaterial.map(e=>{
                        return <Skeleton variant="rectangular" width={210} height={60} />

                       })}
                  </div>
                
                }

          </div>
        
      </div>

       {addPage&&
         <form 
         enctype="multipart/form-data"
         className='singleCategoryAddNewMaterial'>
            <div  className='singleCategoryAddNewMaterialBox'>
                <IconButton onClick={()=>handleAddPage(false)}><CloseIcon style={{color:"red"}}/></IconButton>
                <div className='singleCategoryAddNewMaterialPhotots'>
                    <label>
                          <input type="file" hidden multiple name="img" onChange={handleChange} className='file-input-newPost'/>
                            <div>
                                <AddPhotoAlternateIcon style={{fontSize:"35px"}}/>
                                  <div>Add Photo / video</div>
                            </div>                                  
                    </label>

                </div>
                {sampleImage.length>0&&
                  <div className="singleCategoryAddNewMaterialPhototsSelected">
                                {sampleImage.map(src=>{
                                  return <div><img src={src} width={100} height={100} style={{objectFit:"contain"}}/></div>
                                  })}
                    </div>}

                <div className='singleCategoryAddNewMaterialTextData'>
                      <div className='singleCategoryAddNewMaterialTextDataEach'>
                        <div className='singleCategoryAddNewMaterialTextDataTitle'>Name  </div>
                        <div><Input value={name} onChange={(e)=>setName(e.target.value)}/></div>
                      </div>

                      <div className='singleCategoryAddNewMaterialTextDataEach'>
                        <div className='singleCategoryAddNewMaterialTextDataTitle'>price  </div>
                        <div><Input value={price} onChange={(e)=>setPrice(e.target.value)}/></div>
                      </div>

                      <div className='singleCategoryAddNewMaterialTextDataEach'>
                        <div className='singleCategoryAddNewMaterialTextDataTitle'>Description  </div>
                         <div>  <TextArea 
                                  autoFocus={true}
                                  autoSize={{
                                  minRows:2,
                                  maxRows: 3,
                                  }} 
                              value={description} onChange={(e)=>setDescription(e.target.value)}/></div>
                      </div>
                    
                      {Object.keys(requiredKeys).map((key) => {
                          return (
                            <div className='singleCategoryAddNewMaterialTextDataEach' key={key}>
                              <div className='singleCategoryAddNewMaterialTextDataTitle'>{key}</div>
                              <div>
                                <Input value={requiredKeys[key]} onChange={(e) => setRequiredKeys((prevState) => ({ ...prevState, [key]: e.target.value }))} />
                              </div>
                            </div>
                          );
                        })}

                </div>
                
                {errorMaterialAdd&&<div style={{color:"red"}}>{errorMaterialAdd}</div>}

                <div  className='singleCategoryAddNewMaterialButoon'>
                   {loadMaterialAdd?<CircularProgress size={30}/>:<Button disabled={disablePostButton||!name||!price||!description} onClick={PostMaterial}>Post</Button>}
                </div>
            </div>
         </form>
       }
    </>
  )
}

const EachMaterials=({item,propsData})=>{

  const sum = item.reviews.reduce((acc, num) => acc + num.rate, 0);
  let AveregaRate = sum / item.reviews.length;
  
  function formatNumberWithCommas(number) {
    // Convert the number to a string
    const numberString = number.toString();
  
    // Split the string into integer and decimal parts (if any)
    const parts = numberString.split('.');
  
    // Format the integer part with commas
    const formattedInteger = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  
    // Combine the formatted integer with the decimal part (if any)
    const formattedNumber = parts.length > 1 ? formattedInteger + '.' + parts[1] : formattedInteger;
  
    return formattedNumber;
  }

  let [AddedToCart,HandleAddedToCart]=useState(propsData.userData?.data?.cart?.includes(item?._id))
  let [LoadAddedToCart,HandleLoadAddedToCart]=useState(false)

  const AddToCart=()=>{
    HandleLoadAddedToCart(true)
    let data={
      materialId:item._id
    }
    axios.put(`${process.env.REACT_APP_URL}/api/user/AddRemoveMaterialCart`,data, //proxy uri
    {
       headers: {
          authorization:`Bearer ${ propsData.userData?.token }`,
          'Content-Type': 'application/json'
       } 
    })
    .then(res=>{
      console.log(res.data);
     // HandleLoadAddedToCart(false)
      HandleAddedToCart(res.data.msg==="Removed"?false:true)
    })
    .catch(error=>{
    //  console.log(error);
    })

  }

  return(
    <div 
      className='singleCategoryMaterialsEach singleMaterialMinimized'
      >
               <div className='singleCategoryMaterialsEachImage'>
                    <img src={`${item.images[0].fileUrl}`} width={"100%"} alt={"slider.pic"}/>
                </div>
                <div style={{  padding: "0px 30px 0px 30px"}}>
                    <Link   style={{color:"inherit",textDecoration:"none"}} to={`/materials/${item._id}`}><h3>{item?.name}</h3> </Link>
                    <div className='singleCategoryMaterialsEachImageData'>
                        <div className='singleCategoryMaterialsEachImageDataEachValue'>{formatNumberWithCommas(item.price)}</div>                      
                        <div className="singleCategoryMaterialsEachImageDataRating">
                            <div><Rating name="half-rating-read" value={Math.round(AveregaRate * 10)/10} precision={0.5} readOnly /></div>
                             <div><IconButton onClick={AddToCart}><ShoppingCartIcon style={{color:AddedToCart&&"goldenrod"}}/></IconButton></div>  
                          </div>

                    </div>
                
                </div>
            
  </div>
  )
}


const EachCategories=({item})=>{

  return(
   <Link to={`/categories/${item?._id}`} style={{color:"inherit",textDecoration:"none"}}>
      <div className='singleCategoryEach'>
        <div className='singleCategoryEachName'>{item?.name}</div>
        <div className='singleCategoryEachShop'>from {item?.shop?.shope_name}</div>
      </div>
   
   </Link>
  )
}



